/*********************************************************************************************
 * 📊 CIM TRACKING — events de clics envoyés dans le dataLayer (GTM → GA4)
 *
 * Tout élément avec [data-track] pousse au clic :
 *   { event: 'cim_click', click_name: '<data-track>', ...paramètres }
 *
 * Attributs :
 *   data-track="show_filters"              → nom de l'event (click_name)
 *   data-track-expanded="hide_filters"     → nom utilisé si l'élément a aria-expanded="true" au moment du clic (boutons bascule)
 *   data-track-<param>="valeur"            → paramètre supplémentaire (ex. data-track-product-handle → product_handle)
 *
 * Écoute en phase de capture : l'event part même si un autre script stoppe la propagation,
 * et aria-expanded est lu avant que le bouton ne change d'état. Délégation sur document :
 * fonctionne aussi pour les éléments rechargés en AJAX.
 *
 * Côté GTM : déclencheur « Événement personnalisé » cim_click + balise « Événement GA4 ».
 */

(() => {
    const EVENT_NAME = 'cim_click';
    const RESERVED = ['track', 'trackExpanded'];

    // Paramètres déjà envoyés : remis à undefined aux events suivants,
    // sinon GTM les conserve dans son modèle de données et les rattache à tort aux autres clics
    const usedKeys = new Set();

    // data-track-product-handle → dataset.trackProductHandle → product_handle
    const toParamName = (key) => key
        .replace(/^track/, '')
        .replace(/^[A-Z]/, c => c.toLowerCase())
        .replace(/[A-Z]/g, c => '_' + c.toLowerCase());

    const push = (el) => {
        const expanded = el.getAttribute('aria-expanded') === 'true';
        const clickName = (expanded && el.dataset.trackExpanded) || el.dataset.track;
        if (!clickName) return;

        const params = {};
        Object.keys(el.dataset).forEach(key => {
            if (!key.startsWith('track') || RESERVED.includes(key)) return;
            const value = el.dataset[key];
            if (value !== '') params[toParamName(key)] = value;
        });

        const payload = { event: EVENT_NAME, click_name: clickName };
        usedKeys.forEach(key => { payload[key] = undefined; });
        Object.assign(payload, params);
        Object.keys(params).forEach(key => usedKeys.add(key));

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
    };

    document.addEventListener('click', (e) => {
        const el = e.target.closest('[data-track]');
        if (el) push(el);
    }, true);
})();
